import React from "react";
import { Container, Typography, Button } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EnglishLearningChat from "../components/projects/EnglishLearningChat";
import AITeacherToolbox from "../components/projects/AITeacherToolbox";
import IeltsProject from "../components/projects/IeltsProject";
import HomeworkDigitization from "../components/projects/HomeworkDigitization";
import PodcastGenerator from "../components/projects/PodcastProject";

function ProjectDetail() {
  const { id } = useParams();
  const navigate = useNavigate();

  const renderProjectContent = () => {
    switch (id) {
      case "english-learning-chat":
        return <EnglishLearningChat />;
      case "ai-teacher-toolbox":
        return <AITeacherToolbox />;
      case "liulishuo-ielts":
        return <IeltsProject />;
      case "homework-digitization":
        return <HomeworkDigitization />;
      case "podcast-generator":
        return <PodcastGenerator />;
      default:
        return <Typography>Project not found</Typography>;
    }
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate("/projects")}
        sx={{ mb: 3 }}
      >
        Back to Projects
      </Button>

      {renderProjectContent()}
    </Container>
  );
}

export default ProjectDetail;
